import { render, staticRenderFns } from "./BowMenuLink.vue?vue&type=template&id=88bbcf96&"
import script from "./BowMenuLink.vue?vue&type=script&lang=js&"
export * from "./BowMenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports